// extracted by mini-css-extract-plugin
module.exports = {"settingSwitchContainer":"Profile_settingSwitchContainer__1Ytzt","favourites":"Profile_favourites__Je0dw"};